import { Expose } from "class-transformer";
import { EmployeeDocumentOriginEnum } from "@/core/features/employee-documents/employee-document-origin.enum";

export class RegisterEmployeeDocumentSignedUploadDto {
  @Expose()
  employeeId: string;

  @Expose()
  categoryId: string;

  @Expose()
  storageKey: string;

  @Expose()
  filename: string;

  @Expose()
  mimetype: string;

  @Expose()
  size: number;

  @Expose()
  contentHash: string;

  @Expose()
  origin: EmployeeDocumentOriginEnum;
}
